<!-- MemberManagement.vue -->
<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>学员管理</h1>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="candidateList"
      :page="currentPage"
      :items-per-page="itemsPerPage"
      :server-items-length="totalItems"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': itemsPerPageOptions
      }"
      sort-by="name"
      class="elevation-1"
      @update:page="handlePageChange"
      @update:items-per-page="handleItemsPerPageChange"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small class="mr-2" @click="showDetails(item)">
          <v-icon small>mdi-information-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- 引入并使用 MemberDetails 组件 -->
    <member-details
      :member="currentMember"
      @close="dialog = false"
      ref="details"
    ></member-details>
  </v-container>
</template>

<script>
import { userApi } from '@/api/user'
import MemberDetails from "../components/MemberDetails.vue";

export default {
  components: {
    MemberDetails,
  },
  data() {
    return {
      loading: false,
      dialog: false,
      currentMember: {},
      headers: [
        { text: "名称", value: "name" },
        { text: "账号", value: "account" },
        { text: "最后登入时间", value: "lastLoginDateTime" },
        { text: "操作", value: "actions", sortable: false },
      ],
      candidateList: [],
      currentPage: 1,
      itemsPerPage: 10,
      itemsPerPageOptions: [10,30,50,100],
      totalItems: 100,
    };
  },
  
  async created() {
    await this.fetchCandidateList();
  },

  methods: {
    
    async fetchCandidateList() {
      this.loading = true;
      try {
        const response = await userApi.getCandidateList(this.currentPage, this.itemsPerPage);
        this.candidateList = response.data.candidateBasicInfos;
        this.totalItems = response.data.totalItems
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取列表失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    },

    handlePageChange(newPage) {
      this.currentPage = newPage
      this.fetchCandidateList()
    },

    handleItemsPerPageChange(newSize) {
      this.itemsPerPage = newSize
      this.currentPage = 1
      this.fetchCandidateList()
    },


    showDetails(member) {
      this.$refs.details.open(member.id);
    },
    formatLastLogin(timestamp) {
      const date = new Date(timestamp);
      return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    },
  },
};
</script>